/* eslint-disable */
import _ from 'underscore';
function capValue(value) {
  var maxLength = 100;
  if (!_.isString(value) || value.length < maxLength) {
    return value;
  }
  return value.substring(0, maxLength);
}
function toDescriptionWithDataFilter(filter) {
  var expressions = _.without(filter.FilterExpressions, null, undefined);
  var idStringExpressions = _.filter(expressions, function (expression) {
    return expression.SelectedColumn == 'IdString';
  });
  var otherExpressions = _.reject(expressions, function (expression) {
    return expression.SelectedColumn == 'IdString';
  });
  var compactOthers = _.map(otherExpressions, function (expr) {
    return [expr.SelectedColumn, expr.SelectedOperator, _.map(expr.Values, capValue)];
  });
  if (idStringExpressions.length != 0) {
    var compactIds = [{
      idsCount: idStringExpressions[0].Values.length
    }];
    return JSON.stringify(_.union(compactIds, compactOthers));
  } else {
    return JSON.stringify(compactOthers);
  }
}
function toDescription(filter) {
  if (!filter || !filter.FilterExpressions) {
    return null;
  }
  var expressions = _.without(filter.FilterExpressions, null, undefined);
  if (!_.isArray(expressions) || expressions.length == 0) {
    return null;
  }
  var dataFilterExpressions = _.filter(expressions, function (expression) {
    return expression.SelectedColumn === 'Criterion' || expression.SelectedColumn === 'LevelOfDetails';
  });
  if (dataFilterExpressions.length > 0) {
    return toDescriptionWithDataFilter(filter);
  } else if (filter.idBased) {
    return JSON.stringify({
      idsCount: expressions[0].Values.length
    });
  }
  var compact = _.map(expressions, function (expr) {
    return [expr.SelectedColumn, expr.SelectedOperator, _.map(expr.Values, capValue)];
  });
  return JSON.stringify(compact);
}
function fromDescription(description) {
  var compactFilter, filter;
  if (!description) {
    return null;
  }
  var returnDescription = {};
  compactFilter = JSON.parse(description);
  if (!!compactFilter.idsCount) {
    returnDescription.idBased = true;
    returnDescription.idsCount = compactFilter.idsCount;
    return returnDescription;
  } else if (compactFilter && compactFilter.length > 0 && !!compactFilter[0].idsCount) {
    returnDescription.idBased = true;
    returnDescription.idsCount = compactFilter[0].idsCount;
    compactFilter = compactFilter.slice(1);
  }
  compactFilter = compactFilter && compactFilter.Filter ? compactFilter.Filter : compactFilter;
  filter = _.map(compactFilter, _.bind(_.object, _, ['SelectedColumn', 'SelectedOperator', 'Values']));
  returnDescription.FilterExpressions = filter;
  return returnDescription;
}
function toRuleDescription(filter, acrossAllPages, idsCount) {
  var expressions;
  if (!filter || !filter.FilterExpressions || !_.isArray(filter.FilterExpressions) || filter.FilterExpressions.length == 0) {
    return null;
  }
  expressions = filter.FilterExpressions;
  var result = {};
  if (filter.idBased) {
    result.idsCount = acrossAllPages ? idsCount : expressions[0].Values.length;
  }
  var expressionsToMap = acrossAllPages ? _.without(expressions, expressions[0]) : expressions;
  var compact = _.map(expressionsToMap, function (expr) {
    return _.isEmpty(expr.SelectedNames) ? [expr.SelectedColumn, expr.SelectedOperator, _.map(expr.Values, capValue)] : [expr.SelectedColumn, expr.SelectedOperator, _.map(expr.Values, capValue), _.map(expr.SelectedNames, capValue)];
  });
  result.Filter = compact;
  return JSON.stringify(result);
}
function fromRuleDescription(description) {
  var compact, compactFilter, filter, result = {};
  if (!description) {
    return null;
  }
  compact = JSON.parse(description);
  if (!!compact.idsCount) {
    result = {
      idBased: true,
      idsCount: compact.idsCount
    };
  }
  compactFilter = compact.Filter ? compact.Filter : compact;
  filter = _.map(compactFilter, function (element) {
    var mapped = {
      'SelectedColumn': element[0],
      'SelectedOperator': element[1],
      'Values': element[2]
    };
    if (element[0] === 'Labels' && element.length > 3) {
      mapped.SelectedNames = element[3];
    }
    return mapped;
  });
  result.FilterExpressions = filter;
  return result;
}
function toQueryString(filterExpressions) {
  var expressionStrings = _.map(filterExpressions, function (expression, index) {
    return _.map(expression, function (value, key) {
      var template = 'filter[' + index + '].' + key + '=';
      return _.isArray(value) ? _.map(value, function (val) {
        return template + val;
      }).join('&') : template + value;
    }).join('&');
  });
  return expressionStrings.join('&');
}
export default {
  toDescription: toDescription,
  fromDescription: fromDescription,
  toQueryString: toQueryString,
  toRuleDescription: toRuleDescription,
  fromRuleDescription: fromRuleDescription
};

